(function(angular, _) {
    /**
     * @ngdoc service
     * @name WtObserver
     * @description A basic implementation of the Observer interface from the Observable pattern
     */
    class WtObserver {
        /**
         * As the observable proposal is not yet finalised (https://github.com/tc39/proposal-observable) two ways of subscribing are allowed
         * 1. An object {next, ?error, complete} where error and complete are optional
         * 2. Three callbacks in the order next, error?, complete?
         * @param {Function|Object} onNext On object with {next: Function, error: Function, complete: Function} signature or the callback for next
         * @param {Function|null} onError The `error` callback or null if the first argument is an object
         * @param {Function|null} onComplete The `complete` callback or null if the first argument is an object
         */
        constructor(onNext, onError = null, onComplete = null) {
            const observer = onNext || {};
            this.observer = !_.isFunction(observer)
                ? observer : {next: observer, error: onError, complete: onComplete};

            this.unsubscribed = false;
        }

        /**
         * @ngdoc method
         * @name WtObserver#next
         * @description Notifies the observer about a new value.
         * When errors are encountered, the observer unsubscribes from the observable
         * When the last value was emitted, the complete callback will be invoked
         * @param {*} value
         */
        next(value) {
            if (this.unsubscribed || !_.isFunction(this.observer.next)) {
                return;
            }

            try {
                this.observer.next(value);
            } catch (error) {
                this.unsubscribe();
                throw error;
            }
        }

        /**
         * @ngdoc method
         * @name WtObserver#error
         * @description Notifies the observer about the occurred error. Unsubscribes from the observable.
         * The complete callback is not called when errors are encountered.
         * @param {Error} err
         */
        error(err) {
            if (this.unsubscribed || !_.isFunction(this.observer.error)) {
                return;
            }

            try {
                this.observer.error(err);
            } catch (err2) {
                this.unsubscribe();
                throw err2;
            }

            this.unsubscribe();
        }

        /**
         * @ngdoc method
         * @name WtObserver#complete
         * @description Notifies the observer about the observable completion. This callback is invoked after the last value was emitted.
         */
        complete() {
            if (this.unsubscribed || !_.isFunction(this.observer.complete)) {
                return;
            }

            try {
                this.observer.complete();
            } catch (err2) {
                this.unsubscribe();
                throw err2;
            }

            this.unsubscribe();
        }

        /**
         * @ngdoc method
         * @name WtObserver#unsubscribe
         * @description Unsubscribes from the observable. Will ignore all subsequent values.
         */
        unsubscribe() {
            this.unsubscribed = true;
        }
    }

    angular.module('wtApp.dataService')
        .factory('WtObserver', () => WtObserver);
})(window.angular, window._);
